import { Component, ElementRef, Input, SimpleChanges, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CommonService } from 'src-adisco/services/common.service';
import { UserService } from 'src/app/admin/core/services/user.service';
import { DynamicDocumentInfoService } from 'src/app/shared/services/dynamic-document-info.service';
import { DynamicDocumentService } from 'src/app/shared/services/dynamic-document.service';
interface UrlFile {
  nameFile: string;
  nameFileDetail: string;
  urlFile: string;
  imgURL?: string;

}
@Component({
  selector: 'app-detail-info',
  templateUrl: 'detail-info.component.html',
  styleUrls: ['./detail-info.component.css'],
})
export class DetailInfoComponent {


  @Input() item: any;
  @Input()  listUrlImageProduct: UrlFile[] = []; // List of images
  @ViewChild("detailInfo") detailInfo: ElementRef | undefined;
  code!: string;
  dataSupplier!: any;
  listIdTariff: any[] = [];
  listDataTariff: any[] = [];
  priceCurrent: any[] = [];
  pricePrev: any[] = [];
  idProduct!: any;
  visibleItem: boolean = false;
  itemPdfShow: any;
  pdfLoaded: boolean = false;
  allResultParse: any;

  listImageSustainableDevelopments = [
    {
      id: 1,
      field: 'europeanEcolabel',
      label: 'Ecolabel Européen',
      urlImage: 'src-adisco/assets/images/sustainable-developments/ECOLABEL_EUROPEEN.png'
    },
    {
      id: 2,
      field: 'cradleToCradle',
      label: 'Cradle to Cradle (C2C)',
      urlImage: 'src-adisco/assets/images/sustainable-developments/cradle-to-cradle.png'
    },
    {
      id: 3,
      field: 'nordicSwan',
      label: 'Nordic Swan',
      urlImage: 'src-adisco/assets/images/sustainable-developments/swan_nordic_label.png'
    },
    {
      id: 4,
      field: 'austrianEcolabel',
      label: 'Ecolabel Autrichien',
      urlImage: 'src-adisco/assets/images/sustainable-developments/ecolabel_autrichien.png'
    },
    {
      id: 5,
      field: 'ecocert',
      label: 'Ecocert',
      urlImage: 'src-adisco/assets/images/sustainable-developments/Logo_Ecocert_Colour.png'
    },

    {
      id: 6,
      field: 'emas',
      label: 'EMAS',
      urlImage: 'src-adisco/assets/images/sustainable-developments/EMAS.png'
    },
    {
      id: 7,
      field: 'fsc',
      label: 'FSC',
      urlImage: 'src-adisco/assets/images/sustainable-developments/FSC.png'
    },
    {
      id: 8,
      field: 'reach',
      label: 'REACH',
      urlImage: 'src-adisco/assets/images/sustainable-developments/REACHCompliant.png'
    },
    {
      id: 9,
      field: 'foodContact',
      label: 'Contact alimentaire',
      urlImage: 'src-adisco/assets/images/sustainable-developments/1200px-EU_food_contact_material_symbol.png'
    },
    {
      id: 10,
      field: 'clpSafetyPicto',
      label: 'CLP (pictos de sécurité)',
      urlImage: 'src-adisco/assets/images/sustainable-developments/sans-picto-danger.svg',
      parseToBooleanValueTrue: "SANS"
    },
    {
      id: 11,
      field: 'biocide',
      label: 'BIOCIDE',
      urlImage: 'src-adisco/assets/images/sustainable-developments/Produit_Biocide.png'
    }
  ];

  dataDetailProperties: any;
  dataDetailPropertiesBySide: any = {
    left: [],
    right: []
  };

  ngOnInit() {
    this.idProduct = this._activeRouter.snapshot.paramMap.get('id');

    this.code = this.item?.nameSupplier[0]?.value;
    if (this.code) {
      this.getSupplier(this.code);
    }
    if (this.item?.linkToTariff && this.item?.linkToTariff[0]) {
      this.item?.linkToTariff.forEach((item: any) => {
        this.listIdTariff.push(item?.documentId);
      });
      this.getTariff(this.listIdTariff)
    }

    this.getDynamicProductLabel();

  }

  constructor(
    private _commonService: CommonService,
    private dynamicDocumentService: DynamicDocumentService,
    private _activeRouter: ActivatedRoute,
    private dynamicDocumentInfoService: DynamicDocumentInfoService,
    public userService: UserService
  ) {
    this._commonService.getClickEvent().subscribe((res) => {
      this.detailInfo?.nativeElement.scrollIntoView({ behavior: 'smooth' });
    });
  }

  getSupplier(code: string): void {
    this.dynamicDocumentService.find({
      collectionName: 'dynamic_legal_entity',
      filters: [
        {
          "fieldName": "code",
          "conditions": [
            {
              "type": "EQUALS",
              "value": code
            }
          ]
        }
      ],
      page: 1,
      pageSize: 150
    })
      .subscribe((res: any) => {
        this.dataSupplier = res?.content[0];
      });
  }

  getTariff(ids: any[]): void {
    this._commonService.getDataTariff(ids).subscribe({
      next: (res) => {

        const data = res.response;
        data.forEach((item: any) => {
          if (item?.year && item?.year?.value === "N") {
            this.priceCurrent.push(item);
          }
          if (item?.year && item?.year?.value === "N-1") {
            this.pricePrev.push(item);
          }
        });
      },
      error: (_error) => { },
    });
  }

  openFile(item: UrlFile) {
    if (item?.imgURL) {
      return;
    }
    this.itemPdfShow = item;
    this.visibleItem = true;
  }

  getDynamicProductLabel() {
    this.dynamicDocumentInfoService
      .findByDocumentName(
        'dynamic_product',
        true
      ).subscribe({
        next: (res) => {
          let result: any = JSON.parse(JSON.stringify(this.item));

          res.fields.forEach((field: any) => {
            if (result[field.name] || typeof result[field.name] === "boolean") {
              result[field.name] = {
                value: result[field.name],
                variableLabel: field?.label?.fr_FR,
                type: field.type
              };
            }
          });

          this.allResultParse = { ...result };

          // reset
          this.dataDetailProperties = [];
          this.dataDetailPropertiesBySide = {
            left: [],
            right: []
          };

          const displayInfoListLeft = [
            'countryOfManufacture',
            'supplierProductCategory',
            'identifiedUses',
            'pureAppearance',
            'colorAtRecommendedDilution',
            'odourAtRecommendedDilution',
            'nanoParticulateSubstances',
            'pureProductConcentrationRate',
            'phOfPureProduct',
            'flashPoint',
            'waterSolubility',
            'colour1',
            'colour3',
            'printingPersonalisation',
            'internalDiameter',
            'screwEndDiameter',
            'chuckDiameter',
            'productLength',
            'productHeightThickness',
            'foldedFormatLength',
            'foldedFormatWidth',
            'unfoldedFormatHeight',
            'thickness',
            'embossing',
            'technology',
            'impregnatedProduct',
            'application',
            'minimumRecommendedDilutionRateForUse',
            'recommendedUseRestrictions',
            'percentageOfRecycledProduct',
            'h220',
            'h223',
            'h225',
            'h228',
            'h302',
            'h318',
            'h410',
            'h412',
            'ghs03PureProduct',
            'ghs06PureProduct',
            'ghs08PureProduct',
            'euh031',
            'precautionaryStatementsOnPureProductLabels',
            'safetyAdvicePureProduct',
            'hazardousComponentsPureProduct',
            'hygieneMeasuresPureProduct',
            'handProtectionPureProduct',
            'respiratoryProtectionPureProduct',
            'handProtectionAtRecommendedUseDilution',
            'respiratoryProtectionAtRecommendedUseDilution',
            'ecotoxicity',
            'fdaApproved',
            'binBagLink',
            'density',
            'standardNumberNf',
            'moistureAbsorption',
            'resistanceToSoiling',
            'washable',
            'withBellows',
            'standardOpacity',
            'withWheel',
            'selectiveSorting',
            'wallMounting',
            'recommendedSterilisationTemperature',
            'maxOperatingTemperature',
            'shelfLife',
            'size',
            'abrasivePower',
            'productBiodegradability',
            'resultsOfPbtAndVpvbAssessments',
            'classifiedFacilitiesnEnvironmentalProtection',
            'pushButtonLockingSystem',
            'batteriesSuppliedForAutomaticSystems',
            'resistanceToWetWaste',
            'spout',
            'tank',
            'declarationOfConformity',
            'durabilityM2',
            'particleSize',
            'hepaFiltration',
            'exhaustFilter',
            'cableLength',
            'indicatedPower',
            'maxMiniPowerOutput',
            'airFlowVacuum',
            'frequency',
            'energyCategory',
            'noiseLevelDb',
            'noiseLevelDbAtWork',
            'workingRange',
            'numberOfFilters',
            'flexibleDiameter',
            'tankFillingCapacity',
            'cableColour',
            'protectionSafetyClass',
            'suctionWidth',
            'wasteWaterTank',
            'brushPressure',
            'highSpeed',
            'biSpeed',
            'operatingTime',
            'automaticBrushStop',
            'batteryLevelIndicator',
            'adjustableHandle',
            'travelSpeed',
            'protectiveCircuitBreaker',
            'reverseGear'
          ];

          const displayInfoListRight = [
            'customsNomenclature',
            'deee',
            'material',
            'dilutedAppearance',
            'pureProductSmell',
            'substanceType',
            'volume',
            'dilutedProductConcentrationRate',
            'phOfDilutedProduct',
            'relativeDensity',
            'categoryEpi',
            'colour2',
            'decorated',
            'diameter',
            'outsideDiameter',
            'builtInScrewCap',
            'chuckInternalDiameter',
            'productWidthDepthLaize',
            'quantityOfProductInKilog',
            'foldedFormatHeight',
            'unfoldedFormatLength',
            'numberOfUnfoldedFormats',
            'grammage',
            'numberOfFolds',
            'virginFibre',
            'absorptionRate',
            'discDiameter',
            'dilutionRateAtMaximumRecommendedDilutionForUse',
            'limitedUsefulLifeFromDateOfManufacture',
            'specialPrecautions',
            'h222',
            'h224',
            'h226',
            'h290',
            'h314',
            'h400',
            'h411',
            'ghs02PureProduct',
            'ghs05PureProduct',
            'ghs07PureProduct',
            'ghs09PureProduct',
            'otherPleaseSpecify',
            'hazardStatementOnPureProductLabel',
            'precautionaryAdviceAtRecommendedDilution',
            'hazardousComponentsAtRecommendedDilution',
            'eyeAndFaceProtectionPureProduct',
            'skinAndBodyProtectionPureProduct',
            'hygieneMeasuresAtRecommendedUseDilution',
            'skinAndBodyProtectionAtRecommendedUseDilution',
            'concernedIcpe1436',
            'rightLeftAmbidextrous',
            'halalCompliance',
            'starFold',
            'frenchStandard',
            'certification',
            'linting',
            'traffic',
            'passage',
            'standardNominalThickness',
            'tearAndDropResistance',
            'withPedal',
            'withLid',
            'binBagHolderForWallOrPostMounting',
            'maxCleaningTemperature',
            'minimumOperatingTemperature',
            'fireResistance',
            'sizeShoes',
            'absorptionPower',
            'biodegradabilityComponent',
            'environmentalHazards',
            'keyLockingSystem',
            'screwsAndBoltsSupplied',
            'litrageVolumeLitres',
            'inclinedBushing',
            'graduated',
            'telescopicHandler',
            'productivity',
            'aggressivenessOfTheDisc',
            'paintInsideTheTank',
            'numberOfSpeeds',
            'technicalSpecifications',
            'protectionClass',
            'powerConsumption',
            'airFlowRateVacuumWithoutHose',
            'voltage',
            'typeOfSuction',
            'numberOfKwhYear',
            'noiseLevelDbEcoMode',
            'tubeLength',
            'surfaceAreaOfMainFilter',
            'flexibleLength',
            'dustWaterWaterDustHoover',
            'maxDustBagCapacity',
            'splashProtection',
            'washingWidth',
            'cleanWaterTank',
            'brushDiscRotationSpeed',
            'lowSpeed',
            'battery',
            'loadingTime',
            'builtInCharger',
            'automaticSolutionStop',
            'toollessBrushChange',
            'cleaningSpeed',
            'turningRadius',
            'theoreticalYield',
            'otherFeaturesOrVideoLinks'
          ];

          const totalCount = {
            left: 0,
            right: 0
          };

          const dataByKeyCheck: any = {
          };


          Object.entries(result)
            .map(([key, value]) => {
              const element = {
                key: key,
                value: value as any
              } as any;

              if (
                (displayInfoListLeft.includes(element.key) || displayInfoListRight.includes(element.key))
                && value && (element?.value?.value || typeof element?.value?.value === "boolean")
                && (!Array.isArray(element?.value.value) || element?.value.value.length > 0)
              ) {
                element.variable = element.key;
                element.key = element.value.variableLabel;
                element.type = element.value.type;
                element.value = element.value.value;

                if (displayInfoListLeft.includes(key)) {
                  totalCount.left += 1;
                } else if (displayInfoListRight.includes(key)) {
                  totalCount.right += 1;
                }

                dataByKeyCheck[key] = element;

                return element;
              }
              return null;
            }).filter((element: any) => element !== null);

          const maxLengthForSide = Math.max(totalCount.left, totalCount.right);

          const realLeftKeys = displayInfoListLeft.filter((key) => dataByKeyCheck[key]);
          const realRightKeys = displayInfoListRight.filter((key) => dataByKeyCheck[key]);


          Array(maxLengthForSide).fill(0).forEach((_item, index) => {
            const dataLeft = dataByKeyCheck[realLeftKeys[index]] ?? null;
            const dataRight = dataByKeyCheck[realRightKeys[index]] ?? null;
            if (dataLeft) {

              this.dataDetailPropertiesBySide.left.push(dataLeft);
              this.dataDetailProperties.push(dataLeft);
            }

            if (dataRight) {
              this.dataDetailPropertiesBySide.right.push(dataRight);
              this.dataDetailProperties.push(dataRight);
            }
          })
        },
        error: (_error) => {
        },
      });
  }

  isObjectValue(value: any): boolean {
    return typeof value === 'object' && !Array.isArray(value) && value !== null
  }

  pageProgress(_event: any) {
    this.pdfLoaded = false;
  }

  pageRendered(_event: any) {
    // this.pdfLoaded = true; // causing glitch
  }

  displayImgSusDev(imgSusDev: any, itemData: any) {
    let expectedValue = typeof itemData === "boolean" ? itemData : (itemData?.value ?? undefined);

    if (imgSusDev?.parseToBooleanValueTrue !== null && imgSusDev?.parseToBooleanValueTrue !== undefined) {
      return expectedValue === imgSusDev.parseToBooleanValueTrue
    }

    return expectedValue ?? false;
  }

  public onDownload(event: any): void {
    event.preventDefault();
    event.stopPropagation();

    if (!this.itemPdfShow || !this.itemPdfShow.urlFile) {
      return;
    }

    let fileName: string = this.itemPdfShow.urlFile;
    fileName = fileName.substring(fileName.indexOf('/resource-files/') + '/resource-files/'.length);
    fileName = fileName.substring(0, fileName.indexOf('?'));

    if (this.hasUuid(fileName)) {
      fileName = fileName.substring(fileName.indexOf('_') + 1);
    }
    fileName = decodeURIComponent(fileName).toUpperCase().replace(/ /g, '-');
    fileName = fileName.replace(/["'&=$€*\/+\[\]{}|]/g, '-');

    this._commonService.downloadFile(this.itemPdfShow.urlFile, fileName);
  }

  private hasUuid(fileName: string): boolean {
    const uuid: string = fileName.substring(0, fileName.indexOf('_'));
    return (uuid.match(/-/g) || []).length === 4;
  }

  /**
   * Format date to DD/MM/YYYY format
   * Handles both Date objects and ISO date strings
   */
  formatDate(dateValue: any): string {
    if (!dateValue) {
      return '-';
    }

    let date: Date;

    // If it's already a Date object
    if (dateValue instanceof Date) {
      date = dateValue;
    }
    // If it's a string (ISO format like "2025-07-01")
    else if (typeof dateValue === 'string') {
      date = new Date(dateValue);
    }
    // If it's a number (timestamp)
    else if (typeof dateValue === 'number') {
      date = new Date(dateValue);
    }
    else {
      return String(dateValue);
    }

    // Validate the date
    if (isNaN(date.getTime())) {
      return String(dateValue);
    }

    // Format to DD/MM/YYYY
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }
}
